module.exports = __webpack_public_path__ + "img/faro-spa.a33d63ef.jpg";